// extracted by mini-css-extract-plugin
module.exports = {"footerBottomSection":"RDIgPs","copyrights":"_2MTX14","nav":"_3O_jdb","navItem":"_3lSKdO"};